function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFECB3",
  d: "M30 10L18 6 6 10 6 42 18 38 30 42 42 38 42 6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE082",
  d: "M18 6L18 38 30 42 30 10z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#9C27B0",
  d: "M27.688,28.46c0-1.13,0.138-2.031,0.414-2.7c0.277-0.67,0.783-1.33,1.521-1.98c0.736-0.648,1.227-1.178,1.472-1.586c0.244-0.408,0.365-0.838,0.365-1.291c0-1.365-0.635-2.047-1.904-2.047c-0.603,0-1.084,0.184-1.446,0.551c-0.362,0.368-0.552,0.875-0.568,1.521H24c0.016-1.541,0.519-2.748,1.508-3.621C26.496,16.437,27.846,16,29.555,16c1.726,0,3.064,0.414,4.018,1.242C34.523,18.069,35,19.236,35,20.746c0,0.687-0.154,1.334-0.464,1.943c-0.31,0.61-0.851,1.286-1.624,2.029l-0.988,0.932c-0.619,0.59-0.973,1.279-1.063,2.071l-0.049,0.738H27.688z M27.332,32.168c0-0.539,0.186-0.982,0.557-1.334c0.37-0.349,0.844-0.524,1.422-0.524s1.052,0.176,1.422,0.524c0.371,0.352,0.557,0.795,0.557,1.334c0,0.529-0.182,0.968-0.544,1.313C30.383,33.826,29.904,34,29.311,34s-1.072-0.174-1.436-0.52C27.514,33.136,27.332,32.697,27.332,32.168z"
});

const SvgNoAddress = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoAddress, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-address.11475e60.svg";
export { ForwardRef as ReactComponent };